// extracted by mini-css-extract-plugin
export var productImage = "_va-0";